import { useCallback, useEffect, useState } from "react";
import axiosInstance from "services/axiosInstance";
import * as S from "./style";
//Hooks
import useLoading from "../../../../hooks/useLoading";
//Components
import Loading from "../../../Loading";
import LayoutDetails from "../../../LayoutModal/LayoutDetails";
//Inteface
import { ICustomer } from "Interfaces/ICustomerAddress";
//Utils
import FormatarData from "utils/FormatData";
import CalculateYear from "utils/CalculateYear";
//Icons
import { FlagBanner } from "@phosphor-icons/react";

interface IDetails {
  isOpenModalDetails: boolean;
  setModalClose: () => void;
  selectedUrlId: number | null;
}

export default function Details({
  isOpenModalDetails,
  setModalClose,
  selectedUrlId,
}: IDetails) {

  const [data, setData] = useState<ICustomer | null>(null);
  const { isLoading, startLoading, stopLoading } = useLoading();

  const fetchData = useCallback(async () => {
    if (!selectedUrlId) return;

    startLoading();
    try {
      const response = await axiosInstance.get(`customer/${selectedUrlId}`);
      setData(response.data);
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    } finally {
      stopLoading();
    }
  }, [selectedUrlId]);

  useEffect(() => {
    if (isOpenModalDetails && selectedUrlId !== null) {
      fetchData();
    } else {
      setData(null);
    }
  }, [isOpenModalDetails, selectedUrlId]);

  if (isOpenModalDetails) {
    return (
      <LayoutDetails
        title="Detalhes do Cliente"
        subTitle="Veja todos os detalhes disponíveis sobre o cliente."
        setModalClose={setModalClose}
      >
        {isLoading || !data ? ( // Se estiver carregando ou os dados forem nulos, mostra o loading
          <Loading />
        ) : (
          <S.Content>
            <S.Header>
              <S.ContentInfor>
                <S.Infor className={data.flag || ''}>
                  <p>Nome:</p>
                  <span>
                    {
                      data.flag &&
                      <FlagBanner size={16} weight="fill" />
                    }
                    {`${data.full_name || "-"}`}
                  </span>
                </S.Infor>

                <S.Infor>
                  <p>CPF:</p>
                  <span>{`${data.cpf || "-"}`}</span>
                </S.Infor>

                <S.Infor>
                  <p>Contato:</p>
                  <span>{`${data.phone_primary || "-"}`}</span>
                </S.Infor>
                {
                  data.birth_date && (
                    <S.Infor>
                      <p>Data de Nascimento:</p>
                      <span>
                        {`${FormatarData(data.birth_date, 'default') || "-"}`}
                        ({`${CalculateYear(data.birth_date) || "-"}`})
                      </span>
                    </S.Infor>
                  )
                }
              </S.ContentInfor>
            </S.Header>

            <S.Body>
              <S.FeaturedSection>
                <S.ContentBody>
                  <S.InforBody>
                    <p>Convênio</p>
                    <S.Description>{data.agreements?.agreement || "-"}</S.Description>
                  </S.InforBody>

                  <S.InforBody>
                    <p>E-mail</p>
                    <S.Description>{data.email || "-"}</S.Description>
                  </S.InforBody>
                </S.ContentBody>


                <S.InforBody>
                  <p>Número do Convênio</p>
                  <S.Description>{data.number_agreement || "-"}</S.Description>
                </S.InforBody>
              </S.FeaturedSection>

              <S.ContentInfor>
                <S.Section>
                  <S.ContentBody>
                    <S.InforBody>
                      <p>CEP</p>
                      <span>{data.address?.cep || "-"}</span>
                    </S.InforBody>

                    <S.InforBody>
                      <p>Rua</p>
                      <span>{data.address?.street || "-"}</span>
                    </S.InforBody>

                    <S.InforBody>
                      <p>Referência</p>
                      <span>{data.address?.reference || "-"}</span>
                    </S.InforBody>

                    <S.InforBody>
                      <p>Complemento</p>
                      <span>{data.address?.complement || "-"}</span>
                    </S.InforBody>
                  </S.ContentBody>

                  <S.ContentBody>
                    <S.InforBody>
                      <p>Número</p>
                      <span>{data.address?.number || "-"}</span>
                    </S.InforBody>

                    <S.InforBody>
                      <p>Bairro</p>
                      <span>{data.address?.neighborhood || "-"}</span>
                    </S.InforBody>
                  </S.ContentBody>

                  <S.ContentBody>
                    <S.InforBody>
                      <p>Cidade</p>
                      <span>{data.address?.city || "-"}</span>
                    </S.InforBody>

                    <S.InforBody>
                      <p>UF</p>
                      <span>{data.address?.uf || "-"}</span>
                    </S.InforBody>
                  </S.ContentBody>
                </S.Section>
              </S.ContentInfor>

              <S.InforBody>
                <S.InforSmall>Cadastrado em: {FormatarData(data.created_at || "-")}</S.InforSmall>
                <S.InforSmall>Ultima atualização em: {FormatarData(data.updated_at) || "-"}</S.InforSmall>
              </S.InforBody>
            </S.Body>
          </S.Content>
        )}
      </LayoutDetails>
    );
  }
  return null;
}
